import type { JSX, SelectHTMLAttributes } from 'react'

export interface SelectOption {
  value: string
  label: string
  disabled?: boolean
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  label?: string
  error?: string
  required?: boolean
  options: SelectOption[]
  placeholder?: string
}

export function Select({
  label,
  error,
  required,
  options,
  placeholder,
  className = '',
  id,
  ...props
}: SelectProps): JSX.Element {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')
  const selectClass = ['fui-input', error ? 'fui-input-error' : '', className]
    .filter(Boolean)
    .join(' ')

  return (
    <div>
      {label && (
        <label htmlFor={inputId} className={`fui-label ${required ? 'fui-label-required' : ''}`}>
          {label}
        </label>
      )}
      <select
        id={inputId}
        className={selectClass}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p id={`${inputId}-error`} className="fui-error" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
